export const LOGO_URL =
  "https://customer-assets-39nsmqrw.emergentagent.net/job_572492d8-6619-4d26-ab28-e00ff46e98fa/artifacts/hkkeuzx4_Rayasthaila_Logo.png";
export const COMPANY = "Rayasthaila Consultancy Pvt. Ltd.";
export const TAGLINE = "CONNECTING MARKETS. CREATING OPPORTUNITIES.";
export const PHONE_DISPLAY = "+91 77424 29898";
export const PHONE_HREF = "tel:+917742429898";
export const EMAIL = "contact@rayasthaila.com";
export const TRADE_IMG =
  "https://images.unsplash.com/photo-1673896493356-6684ede37a7d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwyfHxnbG9iYWwlMjB0cmFkZSUyMGNhcmdvJTIwc2hpcCUyMHBvcnQlMjBzdW5zZXR8ZW58MHx8fHwxNzkwNjg4MjEwfDA&ixlib=rb-4.1.0&q=85";
export const ARCH_IMG =
  "https://images.unsplash.com/photo-1662710072888-b7dc84d25c99?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBleGVjdXRpdmUlMjBidXNpbmVzcyUyMGFyY2hpdGVjdHVyZSUyMHJveWFsJTIwYmx1ZSUyMGxpZ2h0aW5nfGVufDB8fHx8MTc5MDY4ODIxMHww&ixlib=rb-4.1.0&q=85";
export const FOUNDER_IMG =
  "https://customer-assets-0z36b82j.emergentagent.net/job_market-gateway-8/artifacts/pfak0m6d_1691987990857.jpeg";
export const WHATSAPP_URL = "https://wa.me/917742429898";
